import React from "react";
import Overlay from "../Overlay";
import SimpleTable from "../tables/SimpleTable";
import FilterCard, { FIELD_TYPE, ReactSelect } from "../FilterCard";
import {
  getNumPages,
  getPageOptions,
  parseDate,
  showModalNoOutsideClick,
  slicePages,
} from "../../util/FormatUtil";
import { sweetalert } from "../../App";
import Select from "react-select";
import NetworkUtil from "../../network/NetworkUtil";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";
import ConnectAPI from "../../network/ConnectAPI";
import PaginationTool from "../PaginationTool";
import moment from "moment";
import HL7PreviewModal from '../modals/HL7PreviewModal';
// import ExemptionRecordModal from "../modals/ExemptionRecordModal";




const ITEMS_PER_PAGE = 25;

const INITIAL_FILTER = {
  ReqNum: null,
  FacilityIDs: [],
  Method: null,
  BeginSentDate: null,
  EndSentDate: null,
  BeginReceivedDate: null,
  EndReceivedDate: null,
};

interface HL7MessagesManagementState {
  showLoading: boolean
  selectedMessage
  messageQueryResults
  tableData: {}[]
  filter?: {
    ReqNum,
    FacilityIDs,
    Method
    BeginSentDate,
    EndSentDate,
    BeginReceivedDate,
    EndReceivedDate,
  }
  direction?: TableOrder
  page_options: ReactSelect[]
  selected_page?: { label, value }
}

export class HL7MessagesManagement extends React.Component<
  any,
  HL7MessagesManagementState
> {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: false,
      selectedMessage: {},
      tableData: [] as any,
      messageQueryResults: [] as any,
      filter: { ...INITIAL_FILTER },
      direction: 'asc',
      page_options: [{ label: "1", value: "1" }],
      selected_page: { label: "1", value: 1 },
    };

    // this.createOrModifyService = this.createOrModifyService.bind(this);
  }

  clearFilterState: () => void = null;
  // Incremented by each search and by Clear, so a response that comes back after Clear is ignored
  searchID = 0;

  clearFilters() {
    if (this.clearFilterState) {
      this.clearFilterState();
    }
    this.searchID++;
    this.setState({
      showLoading: false,
      filter: { ...INITIAL_FILTER },
      tableData: [],
      messageQueryResults: [],
      selected_page: { label: "1", value: 1 },
    });
  }

  componentDidMount() {
    document.title = 'HL7 Messages Management | Maine Health and Environmental Testing Laboratory';
  }


  queryHL7MessageData(page: number) {
    if (this.state.filter.BeginSentDate || this.state.filter.EndSentDate) {
      let valid = true;
      valid = this.dateCheck(this.state.filter.BeginSentDate, this.state.filter.EndSentDate, "Begin Sent Date", "End Sent Date", "Sent Date")
      if (!valid) {
        return
      }
    }
    if (this.state.filter.BeginReceivedDate || this.state.filter.EndReceivedDate) {
      let valid = true;
      valid = this.dateCheck(this.state.filter.BeginReceivedDate, this.state.filter.EndReceivedDate, "Begin Received Date", "End Received Date", "Received Date")
      if (!valid) {
        return
      }
    }
    const searchID = ++this.searchID;
    this.setState({ showLoading: true, tableData: [] }, async () => {
      let results = await ConnectAPI.filterHL7Message({
        filter: this.state.filter
      });
      if (searchID !== this.searchID) {
        return;
      }

      if (!results.success) {
        this.setState({ showLoading: false })
        return sweetalert.fire({ title: '', html: "<p aria-live='polite'>Unable to filter messages at this time</p>", icon: 'error' })
      }
      if (results.data.length < 1) {
        this.setState({ showLoading: false, tableData: [], messageQueryResults: null })
        return sweetalert.fire({ title: '', html: "<p aria-live='polite'>No messages returned</p>", icon: 'info' })
      }

      this.setState({
        tableData: slicePages(results.data, page, ITEMS_PER_PAGE),
        messageQueryResults: results.data,
        page_options: getPageOptions(getNumPages(results.data, ITEMS_PER_PAGE)),
        showLoading: false,
      });
    });
  }


  handleExportToCSV() {
    this.setState({ showLoading: true }, async () => {
      await NetworkUtil.downloadCSV(
        "/api/admin/connect/csv",
        "HL7 Messages.xlsx",
        { filter: this.state.filter });
      this.setState({ showLoading: false });
    });
  }

  changePage(page: number) {
    let allMessages = this.state.messageQueryResults;
    let returnData = slicePages(allMessages, page, ITEMS_PER_PAGE);
    this.setState({ tableData: returnData });
  }

  renderMessagesFilterFields() {
    return (
      <FilterCard fields={[
        {
          label: "ReqNum",
          "key": "ReqNum",
          type: FIELD_TYPE.TEXT,
          isFilter: true
        },

      ]} passClearStateFunc={(func) => { this.clearFilterState = func }} filterChanged={(e) => {
        this.setState((prevState) => ({
          filter: {
            ...prevState.filter,
            ...e
          }
        }))
      }}
      />
    )
  }

  useSorter(col: Column) {
    let sorter = new Sorter<any>()

    this.setState({ tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any, this.state.direction), direction: this.state.direction === 'asc' ? 'desc' : 'asc' });
  }

  // Build the file from the message saved in HL7MessageQueue (inbound orders and outbound results)
  downloadHL7File(message) {
    // Include the FHS/BHS/BTS/FTS batch wrapper when one was stored, same as the preview
    const content = [message.FinalFHS, message.FinalBHS, message.FinalHL7, message.FinalBTS, message.FinalFTS]
      .filter(part => part)
      .join('\r');
    const blobUrl = URL.createObjectURL(new Blob([content], { type: 'application/hl7-v2' }));
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = message.ReceivedDate ? `${message.ReqNum}.hl7` : `${message.ReqNum}-result.hl7`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoking right after click() can cancel the download in Firefox and Safari
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  }


  handleDateOnChange(value, state) {
    if (value) {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          [state]: value
        }
      }))
    } else {
      this.setState((prevState) => ({
        filter: {
          ...prevState.filter,
          [state]: null
        }
      }))
    }
  }


  getDateRange(beginStateToSet, beginState, endStateToSet, endState, label, tooltip) {
    return (
      <div className="form-group row">
        <div className={"col-12 col-sm-4"} data-toggle={"tooltip"} data-placement={"top"} title={tooltip} >
          <label htmlFor={label} className={"col-form-label"} > {label} </label>
        </div>
        <div className={"col-12 col-sm-8 pl-0 pr-1"}>
          <div className="row">
            <div className={"col-4"}>
              <label id={`begin${label.replaceAll(' ', '')}Filter`} aria-label={`${label} Begin Search`} htmlFor={label}>Begin: </label>
            </div>
            <div className={"col-8 text-lg-right"} id={label} >
              <input
                className={"form-control"}
                autoComplete={"off"}
                type={"date"}
                name={"beginDate"}
                value={beginState || ""}
                aria-labelledby={`begin${label.replaceAll(' ', '')}Filter`}
                onChange={(e) => this.handleDateOnChange(e.target.value, beginStateToSet)}
              />
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-4"}>
              <label id={`end${label.replaceAll(' ', '')}Filter`} aria-label={`${label} End Search`} htmlFor='endDate'>End: </label>
            </div>
            <div className={"col-8 text-lg-right"} id={label}>
              <input
                className={"form-control"}
                autoComplete={"off"}
                type={"date"}
                name={"endDate"}
                value={endState || ""}
                aria-labelledby={`end${label.replaceAll(' ', '')}Filter`}
                onChange={(e) => this.handleDateOnChange(e.target.value, endStateToSet)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  dateCheck(beginDateState, endDateState, beginLabel, endLabel, label) {
    let valid = true
    if ((beginDateState && !endDateState) || (!beginDateState && endDateState)) {
      sweetalert.fire({
        icon: "error",
        title: "",
        html: `<p aria-live='polite'>Please enter a valid ${beginLabel} and an ${endLabel}</p>`,
      });
      valid = false;
    }

    if (beginDateState > endDateState) {
      sweetalert.fire({
        icon: "error",
        title: "",
        html: `<p aria-live='polite'>${beginLabel} cannot be after ${endLabel}</p>`,
      });
      valid = false;
    }

    if (moment(beginDateState).isAfter(moment(), 'day') || moment(endDateState).isAfter(moment(), 'day')) {
      sweetalert.fire({
        icon: "error",
        title: "",
        html: `<p aria-live='polite'>Cannot search for ${label} in the future</p>`,
      });
      valid = false;
    }
    return valid
  }

  preview(message) {
    this.setState({ selectedMessage: message })
    showModalNoOutsideClick(HL7PreviewModal.ID)
  }

  viewSample(reqNum) {
    sweetalert.fire({
      icon: 'info',
      title: '',
      // text, not html: ReqNum comes from external HL7 orders
      text: `You are leaving the HL7 Messages page to view sample ${reqNum} on the Samples page. Continue?`,
      showCancelButton: true,
      confirmButtonText: 'Go to Samples',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = `/admin/HumanSamples?reqNum=${encodeURIComponent(reqNum)}`;
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <HL7PreviewModal selectedMessage={this.state.selectedMessage} />
        {/* <ExemptionRecordModal
            selectedExemption={this.state.selectedExemption}
            immunizations={this.state.immunizations}
            countries={this.state.countries}
            states={this.state.states}
            genders={this.state.genders}
            races={this.state.races}
            ethnicities={this.state.ethnicities}
            onSubmit={() => {hideModal(ExemptionRecordModal.ID)}}
          /> */}
        <div className="container-fluid ">
          <div className={"row"}>
            <div className="col-12 col-md-12 col-lg-8 col-xl-5 pt-2">
              <main id="main-content" tabIndex={-1} aria-label="HL7 Messages Management">
                <div className="card mb-2">
                  <div className="card-header verlag-bold">
                    <h4>HL7 Messages Management</h4>
                  </div>
                  <div className="card-body">
                    {this.renderMessagesFilterFields()}
                    {this.getDateRange('BeginSentDate', this.state.filter.BeginSentDate, 'EndSentDate', this.state.filter.EndSentDate, 'Sent Date', 'Date outbound HL7 result was sent')}
                    {this.getDateRange('BeginReceivedDate', this.state.filter.BeginReceivedDate, 'EndReceivedDate', this.state.filter.EndReceivedDate, 'Received Date', 'Date inbound HL7 order was received')}
                  </div>
                  <div className="card-footer">
                    <button className={"btn immySubmitButtonOutline"}
                      onClick={() => {
                        this.setState({
                          selected_page: { label: 1, value: 1 }
                        }, () => {
                          this.queryHL7MessageData(this.state.selected_page.value)
                        })
                      }}
                    >Search</button>
                    <button className={"btn immyClearButtonOutline float-right"}
                      onClick={() => this.clearFilters()}
                    >Clear</button>
                  </div>
                </div>
              </main>
            </div>

            <div className="col-md-12 pt-2">
              {
                this.state.tableData &&
                this.state.tableData.length > 0 &&

                <div className="card mt-2" style={{ marginBottom: '4rem' }}>
                  <div className="card-header verlag-bold">
                    <h4 className="text-center text-md-left">Messages
                      <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                        <h4 className={'float-md-right'} aria-label="Total Records" role="alert">Total: {this.state.messageQueryResults.length}</h4>
                        <h4 className="float-right align-middle pr-2 ml-5">Page </h4>
                        <div className="align-middle float-right pages ">
                          <Select
                            isSearchable={true}
                            placeholder={"1"}
                            noOptionsMessage={() => "No option"}
                            value={this.state.selected_page}
                            aria-label="Table Page Number"
                            onChange={(e: ReactSelect) => this.setState({ selected_page: e },
                              () => this.changePage(e.value))}
                            className={"state_select"}
                            options={this.state.page_options}
                          />
                        </div>
                      </section>
                      <button className={"d-none d-md-inline btn btn-outline-primary ml-3"}
                        onClick={() => this.handleExportToCSV()}
                      >Export to CSV
                      </button>
                    </h4>
                  </div>
                  <div className="card-body p-0 m-0 table-responsive">
                    <SimpleTable table_style='tableFixHead' columns={[
                      {
                        label: "Conf #", key: "ReqNum",
                        popoverText: "Click to sort by ReqNum"
                      },
                      {
                        label: "Method", key: "Method",
                        popoverText: "Click to sort by Method",
                      },
                      {
                        label: "Sent Date", key: "SentDate",
                        popoverText: "Click to sort by Sent Date",
                        rawFormat: (val) => {
                          return <p>{parseDate(val.SentDate)}</p>
                        }
                      },
                      {
                        label: "Received Date", key: "ReceivedDate",
                        popoverText: "Click to sort by Received Date",
                        rawFormat: (val) => {
                          return <p>{parseDate(val.ReceivedDate)}</p>
                        }
                      },
                      {
                        label: "Preview", key: "",
                        rawFormat: (val) => (
                          <button
                            type={'button'}
                            className={'btn btn-outline-primary'}
                            onClick={() => this.preview(val)}>Preview
                          </button>)
                      },
                      {
                        label: "HL7 File", key: "",
                        rawFormat: (val) => (
                          // FinalHL7 is null for type=pdf pulls (no HL7 was sent)
                          val.FinalHL7 ? <button
                            type={'button'}
                            className={'btn btn-outline-primary'}
                            onClick={() => this.downloadHL7File(val)}>Download
                          </button> : null)
                      },
                      {
                        label: "Sample", key: "",
                        rawFormat: (val) => (
                          <button
                            type={'button'}
                            className={'btn btn-outline-primary'}
                            onClick={() => this.viewSample(val.ReqNum)}>View Sample
                          </button>)
                      }
                    ]} table_data={this.state.tableData} columnClickedCallback={(col => {
                      this.useSorter(col);
                    })} />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}